import { render, staticRenderFns } from "./GlossarySkeletonPanels.vue?vue&type=template&id=4aa58ab2&scoped=true&"
import script from "./GlossarySkeletonPanels.vue?vue&type=script&lang=js&"
export * from "./GlossarySkeletonPanels.vue?vue&type=script&lang=js&"
import style0 from "./GlossarySkeletonPanels.vue?vue&type=style&index=0&id=4aa58ab2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa58ab2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCol,VRow,VSkeletonLoader})
